module.exports = __webpack_public_path__ + "media/images/common/update_btn_l-5e85d06185a60b561fa5ece4a8a1cf83.png";